var exports = {
  "Tp": "x234b8571--ad074b--background",
  "KI": "x234b8571--ad074b--icon_container",
  "rV": "x234b8571--ad074b--click_area",
  "q9": "x234b8571--ad074b--click_area--left",
  "jW": "x234b8571--ad074b--click_area--disabled",
};

module.exports = exports;
